<!--step="{{step}}"-->
<textarea id="{{getFieldName()}}" [formControl]="field" rows="{{rows}}" class="form-control" [ngClass]="{ 'is-invalid': submitted && field && field.errors }"></textarea>
<app-form-error [field]="field" [submitted]="submitted"></app-form-error>